// Avatar Component
import React from 'react'
import PropTypes from 'prop-types'

const defaultImage = '/images/common/default_planner_assignee.png'

const Avatar = ({ imageUrl, title = '' }) => {
  return (
    <div className='avatar'>
      <img
        className='image'
        src={imageUrl || defaultImage}
        alt={title}
        title={title}
      />
    </div>)
}

Avatar.propTypes = {
  imageUrl: PropTypes.string,
  title: PropTypes.string
}

export default Avatar
